


















import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";

@Component
export default class Accordion extends Vue {
    show: boolean = false;
    @Prop() startShown: boolean;
    
    created() {
        if (this.startShown) {
            this.show = true;
        }
    }
    
    toggle() {
        this.show = !this.show;
    }
}
